<div class="generic-tag-filters">
  <!-- Active Filter Tags -->
  <div class="filter-tags-container" *ngIf="activeFilters.length > 0">
    <div class="filter-tag" *ngFor="let filter of activeFilters">
      <span class="filter-label">{{ filter.displayLabel }}:</span>
      <span class="filter-value">{{ filter.displayValue }}</span>
      <i class="fas fa-times filter-remove" (click)="removeFilter(filter)" title="Remove filter"></i>
    </div>
    <button class="btn btn-sm btn-link clear-all-btn" (click)="clearAllFilters()" *ngIf="activeFilters.length > 1">
      Clear All
    </button>
  </div>

  <!-- Add Filter Button and Dropdown Panel -->
  <div class="add-filter-container">
    <button class="btn btn-sm btn-outline-primary add-filter-btn"
            (click)="openFilterPanel()"
            [disabled]="availableFilters.length === 0">
      <i class="fas fa-filter"></i> Add Filter
    </button>

    <!-- Filter Selection Dropdown Panel -->
    <div class="filter-panel" *ngIf="showFilterPanel">
      <!-- Step 1: Select Filter Type -->
      <div class="filter-selection-step" *ngIf="!selectedFilterConfig">
        <div class="filter-panel-header">
          <h6>Select Filter</h6>
          <i class="fas fa-times close-panel" (click)="closeFilterPanel()"></i>
        </div>
        <div class="filter-panel-body">
          <div class="available-filter"
               *ngFor="let config of availableFilters"
               (click)="onFilterSelected(config)">
            <i [class]="config.iconClass || 'fas fa-filter'" *ngIf="config.iconClass"></i>
            {{ config.label }}
          </div>
          <div class="no-filters" *ngIf="availableFilters.length === 0">
            All filters are currently active
          </div>
        </div>
      </div>

      <!-- Step 2: Configure Filter Value -->
      <div class="filter-config-step" *ngIf="selectedFilterConfig">
        <div class="filter-panel-header">
          <h6>{{ selectedFilterConfig.label }}</h6>
          <i class="fas fa-times close-panel" (click)="closeFilterPanel()"></i>
        </div>
        <div class="filter-panel-body">
          <!-- Dropdown -->
          <div *ngIf="selectedFilterConfig.type === FilterType.Dropdown">
            <dw-search-select-lookup
              *ngIf="selectedFilterConfig.lookupId"
              [(ngModel)]="tempFilterValue"
              [lookupId]="selectedFilterConfig.lookupId"
              [paramValues]="lookupParams"
              [showBlankOption]="false"
              [placeholder]="selectedFilterConfig.placeholder || 'Select...'">
            </dw-search-select-lookup>
            <select class="form-control"
                    *ngIf="selectedFilterConfig.options && !selectedFilterConfig.lookupId"
                    [(ngModel)]="tempFilterValue">
              <option [ngValue]="null">{{ selectedFilterConfig.placeholder || 'Select...' }}</option>
              <option *ngFor="let option of selectedFilterConfig.options" [ngValue]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Multi-Select -->
          <div *ngIf="selectedFilterConfig.type === FilterType.MultiSelect">
            <p-multiSelect
              *ngIf="selectedFilterConfig.options"
              [(ngModel)]="tempFilterValue"
              [options]="selectedFilterConfig.options"
              optionLabel="label"
              optionValue="value"
              [placeholder]="selectedFilterConfig.placeholder || 'Select...'">
            </p-multiSelect>
          </div>

          <!-- Date Range -->
          <div *ngIf="selectedFilterConfig.type === FilterType.DateRange">
            <label class="small-label">Date Range</label>
            <dw-date-range-input [(startDate)]="tempDateRangeStart" [(endDate)]="tempDateRangeEnd"></dw-date-range-input>
          </div>

          <!-- Date Picker -->
          <div *ngIf="selectedFilterConfig.type === FilterType.DatePicker">
            <p-calendar
              [(ngModel)]="tempFilterValue"
              dateFormat="mm/dd/yy"
              [showIcon]="true">
            </p-calendar>
          </div>

          <!-- Toggle -->
          <div *ngIf="selectedFilterConfig.type === FilterType.Toggle">
            <p-inputSwitch [(ngModel)]="tempFilterValue"></p-inputSwitch>
            <span class="ml-2">{{ tempFilterValue ? 'Enabled' : 'Disabled' }}</span>
          </div>

          <!-- Text Input -->
          <div *ngIf="selectedFilterConfig.type === FilterType.TextInput">
            <input type="text"
                   class="form-control"
                   [(ngModel)]="tempFilterValue"
                   [placeholder]="selectedFilterConfig.placeholder || 'Enter value...'">
          </div>

          <div class="filter-actions mt-3">
            <button class="btn btn-sm btn-secondary mr-2" (click)="closeFilterPanel()">Cancel</button>
            <button class="btn btn-sm btn-primary" (click)="applySelectedFilter()">Apply</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
